var _a;
import { createSelector, createSlice } from '@reduxjs/toolkit';
var initialState = {
    isDialogueOpen: false,
    dialogueParams: null
};
export var procedureApplicabilitySlice = createSlice({
    name: 'procedureApplicability',
    initialState: initialState,
    reducers: {
        openProcedureApplicabilityDialogue: function (state, _a) {
            var payload = _a.payload;
            state.dialogueParams = payload;
            state.isDialogueOpen = true;
        },
        closeProcedureApplicabilityDialogue: function (state) {
            state.isDialogueOpen = false;
        }
    }
});
export var openProcedureApplicabilityDialogue = (_a = procedureApplicabilitySlice.actions, _a.openProcedureApplicabilityDialogue), closeProcedureApplicabilityDialogue = _a.closeProcedureApplicabilityDialogue;
export var selectIsProcedureApplicabilityDialogueOpen = createSelector([function (state) { return state.procedureApplicability; }], function (state) { return state.isDialogueOpen; });
export var selectProcedureApplicabilityDialogueParams = createSelector([function (state) { return state.procedureApplicability; }], function (state) { return state.dialogueParams; });
